import { render, staticRenderFns } from "./HirerMsg.vue?vue&type=template&id=36b14ff4&"
import script from "./HirerMsg.vue?vue&type=script&lang=js&"
export * from "./HirerMsg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.7@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports